import { Soundtrack } from 'audio/Soundtrack';
import { FrameType } from 'data/FrameType';
import { ADD_AUDIO, editCaptions, removeSoundtrack } from 'state/actions';
import RootState from 'state/RootState';
import { pause } from 'utils';
import { Command, CommandFunction } from './Command';

export class AddSoundtrackCommand extends Command {
  soundtrack: Soundtrack;
  constructor(soundtrack: Soundtrack) {
    super();
    this.soundtrack = soundtrack;
  }
  execute(firstTime?: boolean): CommandFunction {
    return async (dispatch: Function, getState: () => RootState) => {
      const { soundtrack } = this;
      dispatch({
        type: ADD_AUDIO,
        soundtrack
      });
      if (firstTime) {
        let hasCaptions = false;
        const { layers } = getState().flyer;
        layers.forEach(layer => {
          layer.frames.forEach(frame => {
            if (frame.type === FrameType.Captions) {
              hasCaptions = true;
            }
          });
        });
        if (hasCaptions) {
          await pause(1);
          dispatch(editCaptions());
        }
      }
    };
  }
  undo(): CommandFunction {
    return async (dispatch: Function, getState: () => RootState) => {
      dispatch(removeSoundtrack());
    };
  }
}



// WEBPACK FOOTER //
// ./src/state/commands/AddSoundtrackCommand.ts